var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25580",
    "data-name": "Group 25580",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13609",
    d: "M31.3,17.005V16.7a1.37,1.37,0,0,1,1.848-1.3,13.728,13.728,0,0,1,0,25.658,1.376,1.376,0,0,1-1.848-1.3v-.305a1.4,1.4,0,0,1,.916-1.3,10.693,10.693,0,0,0,0-19.855A1.42,1.42,0,0,1,31.3,17.005ZM14.5,25.176v6.109a1.532,1.532,0,0,0,1.527,1.527h4.582l5.025,5.025a1.532,1.532,0,0,0,2.612-1.084V19.693a1.532,1.532,0,0,0-2.612-1.084l-5.025,5.04H16.027A1.532,1.532,0,0,0,14.5,25.176Zm20.618,3.055A6.873,6.873,0,0,0,31.3,22.076V34.37A6.833,6.833,0,0,0,35.118,28.231Z",
    transform: "translate(0.255 0.269)",
    fill: "#37c5f7",
    fillRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#0074bd",
    strokeWidth: 1,
    strokeDasharray: 296,
    strokeDashoffset: 296
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCard);
export default __webpack_public_path__ + "static/media/audio-card.ed3df5cc76816cbc8625f1b437aebf20.svg";
export { ForwardRef as ReactComponent };